import { Component, HostBinding, Input, OnInit, OnChanges, Output, EventEmitter, inject } from '@angular/core';
import { NavItem } from '@ukam/shell/layouts/full/vertical/sidebar/nav-item/nav-item';
import { Router, isActive } from '@angular/router';
import { NavService } from '@ukam/shell/services/nav.service';
import { TranslocoModule } from '@jsverse/transloco';
import { MaterialModule } from '@ukam/ui-kit/material.module';
import { CommonModule } from '@angular/common';
import { GlobalService } from '@ukam/core/services/global.service';

@Component({
  selector: 'app-nav-item',
  imports: [TranslocoModule, MaterialModule, CommonModule,  TranslocoModule],
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnChanges {
  navService = inject(NavService);
  router = inject(Router);
  globalService = inject(GlobalService);

  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem | any;
  @Input() depth: any;

  constructor() {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    const url = this.navService.currentUrl();
    if (this.item.route && url) {
      this.expanded = url.indexOf(`/${this.item.route}`) === 0;
      this.ariaExpanded = this.expanded;
    }
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);

    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
    //scroll
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (!this.expanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  onSubItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  isMenuActive(item: NavItem): boolean {
    return (
      !!item.route &&
      isActive(item.route, this.router, {
        paths: 'exact',
        queryParams: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })()
    );
  }

  isDirectlyActive(item: NavItem): boolean {
    return (
      !!item.route &&
      isActive(item.route, this.router, {
        paths: 'exact',
        queryParams: 'exact',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })()
    );
  }

  isChildActive(item: NavItem): boolean {
    if (!item.children) return false;
    return item.children.some(
      (child) => this.isDirectlyActive(child) || this.isChildActive(child)
    );
  }

    openNewWindow(item: NavItem): boolean {
    return (
      !!item.route &&
      isActive(item.route, this.router, {
        paths: 'exact',
        queryParams: 'exact',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })()
    );
  }


}
